"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfShadingInfoExportHelper = void 0;
var color_model_info_cache_1 = require("../../../core/model/caches/hashed-caches/color-model-info-cache");
var dx_color_1 = require("../../../core/model/color/dx-color");
var shading_pattern_helper_1 = require("../../../core/model/shadings/shading-pattern-helper");
var RtfShadingInfoExportHelper = (function () {
    function RtfShadingInfoExportHelper() {
    }
    RtfShadingInfoExportHelper.exportShadingPattern = function (rtfBuilder, colorProvider, info, command) {
        var shadingPatternValue = shading_pattern_helper_1.ShadingHelper.calculateShadingPatternValue(info.shadingPattern);
        if (shadingPatternValue >= 0) {
            if (dx_color_1.DXColor.isTransparentOrEmpty(info.backColor.toRgb(colorProvider)) && color_model_info_cache_1.ColorModelInfoCache.defaultItem.equals(info.foreColor) && shadingPatternValue == 0)
                return;
            rtfBuilder.writeIntegerCommand(command, shadingPatternValue * 10);
        }
    };
    RtfShadingInfoExportHelper.exportShadingForeColorIndex = function (rtfBuilder, helper, colorProvider, info, command) {
        if (!color_model_info_cache_1.ColorModelInfoCache.defaultItem.equals(info.foreColor)) {
            RtfShadingInfoExportHelper.exportShadingColorIndexCore(rtfBuilder, helper, colorProvider, info.foreColor, command);
        }
    };
    RtfShadingInfoExportHelper.exportShadingBackColorIndex = function (rtfBuilder, helper, colorProvider, info, command) {
        if (!color_model_info_cache_1.ColorModelInfoCache.defaultItem.equals(info.backColor))
            RtfShadingInfoExportHelper.exportShadingColorIndexCore(rtfBuilder, helper, colorProvider, info.backColor, command);
    };
    RtfShadingInfoExportHelper.exportShadingColorIndexCore = function (rtfBuilder, helper, colorProvider, color, command) {
        if (color_model_info_cache_1.ColorModelInfoCache.defaultItem.equals(color) || dx_color_1.DXColor.isTransparentOrEmpty(color.toRgb(colorProvider)))
            return;
        var rtfColorIndex = helper.getColorIndex(color);
        rtfBuilder.writeIntegerCommand(command, rtfColorIndex);
    };
    return RtfShadingInfoExportHelper;
}());
exports.RtfShadingInfoExportHelper = RtfShadingInfoExportHelper;
